import { GridColumn } from 'src/components/GridWrapper';
import DocumentNumberCell from 'src/sections/po_related_documents/documents_grid/DocumentNumberCell';
import LinkedDocument from 'src/sections/po_related_documents/documents_grid/LinkedDocument';
import TotalDocumentCell from 'src/sections/po_related_documents/documents_grid/TotalDocumentCell';

export const poDocumentsColumns: GridColumn<any>[] = [
  {
    field: 'selected',
    title: '',
    filter: 'text',
    width: '30px',
    menu: false,
    dataType: 'icon',
  },
  {
    field: 'documentNumber',
    title: 'Document #',
    filter: 'text',
    component: DocumentNumberCell,
    format: '',
    dataType: 'number',
  },
  {
    field: 'documentType',
    title: 'Document Type',
    filter: 'text',
    format: '',
    dataType: 'string',
  },
  {
    field: 'linkedDocumentId',
    title: 'Linked Document',
    filter: 'numeric',
    dataType: 'number',
    component: LinkedDocument,
    width: 300,
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'documentQuantity',
    title: 'Document Item QTY',
    filter: 'numeric',
    dataType: 'number',
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'documentTotal',
    title: 'Document Total',
    filter: 'numeric',
    format: '{0:c}',
    component: TotalDocumentCell,
    dataType: 'dollar',
    filterFormat: 'c',
  },
  {
    field: 'status',
    title: 'Status/History',
    filter: 'text',
    format: '',
    dataType: 'string',
  },
  {
    field: 'statusDate',
    title: 'Status Date',
    filter: 'date',
    format: '{0:MM/dd/yyyy}',
    dataType: 'date',
  },
];

export default poDocumentsColumns;
